import React, {useState, useEffect, useRef} from "react";
import * as palette from "../Variables";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Placeholder from "../img/placeholder.jpg";
import styled from "styled-components";
import WorkHero from "../components/WorkHero";
import Insight from "../components/Insight";
import Competitor from "../components/Competitor";
import PainPoint from "../components/PainPoint";
import StickyNav from "../components/StickyNav";
import Persona from "../components/Persona";
import WorkRecommendation from "../components/WorkRecommendation";
import HeroImgDesktop from "../img/dignifi/dignifi-hero-desktop.png";
import HeroImgMobile from "../img/dignifi/dignifi-hero-mobile.png";
import DesignProcess from "../img/design-process.png";
import Competitor1 from "../img/dignifi/dignifi-competitor-1.png";
import Competitor2 from "../img/dignifi/dignifi-competitor-2.png";
import Competitor3 from "../img/dignifi/dignifi-competitor-3.png";
import TargetAudiencePink from "../img/target-audience-pink.png";
import TargetAudienceOrange from "../img/target-audience-orange.png";
import TargetAudienceBlue from "../img/target-audience-blue.png";
import UserInitiationDesktop from "../img/dignifi/dignifi-user-initiation-workflow-desktop.png";
import UserInitiationMobile from "../img/dignifi/dignifi-user-initiation-workflow-mobile.png";
import Sketches from "../img/dignifi/dignifi-sketches.jpg";
import LowWireframes from "../img/dignifi/dignifi-low-wireframes.png";
import HighWireframes from "../img/dignifi/dignifi-high-wireframes.png";
import Final from "../img/dignifi/dignifi-final.jpg";
import Persona1 from "../img/dignifi/dignifi-persona-1.png";
import SouthwestThumbnail from "../img/southwest/southwest-thumbnail.png";
import InsightThumbnail from "../img/insight/insight-thumbnail.jpg";
import SmartHomeThumbnail from "../img/smart-home/smart-home-thumbnail.png";
import Transcript from "../documents/Dignifi-User-Testing-Transcript.pdf";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';


const WorkSection = styled.section`
    padding-top: 44px;
    padding-bottom: 44px;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    flex-flow: column nowrap;
    row-gap: 44px;

    &.grey {
        background-color: ${palette.neutral2};
    }

    &.challenge {
        background: ${palette.gradientMain};

        p, h2 {
            color: ${palette.neutral1};
        }

        p.description {
            font-size: 22px;
        }
    }

    .work-recommendation-container {
        width: 100%;

        @media (min-width: 400px) {
            width: 48%;
        }

        @media (min-width: 650px) {
            width: 32%;
        }
    }

    a:focus-visible {
        outline: 3px solid ${palette.blueMain};
        outline-offset: 8px;
        border-radius: 4px;
    }

    .container.main-container {
        @media (min-width: 1200px) {
            margin-left: 250px;
        }

        @media (min-width: 1600px) {
            margin-left: auto;
        }
    }

    &.reflections {
        background: ${palette.blueMain};

        .label, .h3, p.h4, p {
            color: ${palette.neutral1};
        }

        .summary {
            margin-bottom: 40px;
        }
    }

    .no-left-padding, .no-right-padding {
        padding-left: 0;
        padding-right: 0;
    }

    .h3, .section-title {
        margin-bottom: 16px;
    }

    .img-caption {
        color: ${palette.neutral9};
        margin-bottom: 0 !important;
        margin-top: 16px;
    }

    img {
        border-radius: 8px;
    }

    img.placeholder {
        aspect-ratio: 2/1;
    }

    .work-recommendation-container.left {

        @media (min-width: 576px) {
            padding-right: 24px;
        }
    }

    .work-recommendation-container.middle {

        @media (min-width: 576px) {
            padding-left: 24px;
        }

        @media (min-width: 992px) {
            padding-left: 12px;
            padding-right: 12px;
        }
    }

    .work-recommendation-container.right {

        display: none;

        @media (min-width: 992px) {
            display: block;
            padding-left: 24px;
        }
    }

    @media (min-width: 768px) {
        padding-top: 72px;
        padding-bottom: 72px;
        padding-left: 24px;
        padding-right: 24px;
        row-gap: 72px;

        .no-left-padding {
            padding-left: 0;
        }

        .no-right-padding {
            padding-right: 0;
        }

        .h3, .section-title {
            margin-bottom: 24px;
        }
    }

    @media (min-width: 1200px) {
        &.first {
            margin-top: -456px;
        }
    }

    @media (min-width: 1300px) {
        &.first {
            margin-top: -456px;
        }
    }

    @media (min-width: 1400px) {
        &.first {
            margin-top: -456px;
        }
    }

    .work-elements {
        row-gap: 24px;
        display: flex;
        flex-flow: column nowrap;

        &.overview {
            h1 {
                margin-bottom: 12px;
            }
        }

        @media (min-width: 768px) {
            row-gap: 52px;

            &.overview {
                h1 {
                    margin-bottom: 24px;
                }
            }
        }

        @media (min-width: 1200px) {
            max-width: 850px;
        }

        @media (min-width: 1250px) {
            max-width: 900px;
        }

        @media (min-width: 1300px) {
            max-width: 940px;
        }

        @media (min-width: 1400px) {
            max-width: 1040px;
        }

        @media (min-width: 1500px) {
            max-width: 1096;
        }


        .neutral-9 {
            color: ${palette.neutral9};
        }

        .competitors-container {
            display: flex;
            flex-flow: row wrap;
            column-gap: 20px;
            row-gap: 16px;

            @media (min-width: 768px) {
                column-gap: 60px;
                row-gap: 24px;
            }
        }

        .insights-container {
            display: flex;
            flex-flow: column nowrap;
            row-gap: 28px;
        }

        .pain-points-container {
            row-gap: 20px;
            display: flex;
            flex-flow: column nowrap;

            @media (min-width: 768px) {
                row-gap: 32px;
            }
        }

        .left {
            @media (min-width: 768px) {
                padding-right: 24px;
            }
        }

        .right {
            @media (min-width: 768px) {
                padding-left: 24px;
            }
        }

        h3.audience1 {
            margin-bottom: 12px;

            @media (min-width: 768px) {
                margin-top: 0;
                margin-bottom: 16px;
            }
        }

        h3.audience2 {
            margin-top: 40px;
            margin-bottom: 12px;
            
            @media (min-width: 768px) {
                margin-top: 0;
                margin-bottom: 16px;
            }
        }
    }

    .personas-container {
        display: flex;
        flex-flow: column nowrap;
        row-gap: 40px;

        @media (min-width: 768px) {
            row-gap: 64px;
        }
    }
`;

const persona1Demographics = (
    <div>
        <p style={{marginBottom: 4}}><span>Age: </span>25 years old<br/></p>
        <p style={{marginBottom: 4}}><span>Occupation: </span>Public relations consultant<br/></p>
        <p style={{marginBottom: 4}}><span>Education: </span>Bachelor's degree<br/></p>
        <p style={{marginBottom: 4}}><span style={{lineHeight: 1.5}}>Comfort with technology: </span>4/10</p>
    </div>
);

const persona1Attitudes = (
    <ul>
        <li>Open to adopting new tools and applications that can enhance her digital experiences</li>
        <li>Curious about the ways her personal data is collected and how she can make use of it</li>
        <li>Cautious about sharing data with companies and prefers platforms that prioritize user privacy and security</li>
    </ul>
);

const persona1Behaviors = (
    <ul>
        <li>Maintains an active presence on social media and other online platforms</li>
        <li>Explores new technologies and applications that can streamline her work and personal life</li>
    </ul>
);

const persona1Goals = (
    <ul>
        <li>Data transparency</li>
        <li>Personal empowerment</li>
    </ul>
);

const persona1Frustrations = (
    <ul>
        <li>Data fragmentation</li>
        <li>Information overload</li>
        <li>Privacy concerns</li>
    </ul>
);

const DignifiAppDesign = () => {
    const [scrollY, setScrollY] = useState(window.scrollY);
    
    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const getScrollMarginTop = (ref) => {
        if (!ref.current) return 0;
        const sectionTop = ref.current.getBoundingClientRect().top + window.scrollY;
        return sectionTop > scrollY ? 0 : 135;
    };

    const overviewRef = useRef(null);
    const generalResearchRef = useRef(null);
    const userResearchRef = useRef(null);
    const challengeRef = useRef(null);
    const analysisRef = useRef(null);
    const iterationsRef = useRef(null);
    const finalDesignRef = useRef(null);
    const reflectionsRef = useRef(null);

    const [showHeader, setShowHeader] = useState(true);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1200);
    const lastScrollY = useRef(window.scrollY);

    useEffect(() => {
        const handleScroll = () => {
        const currentScrollY = window.scrollY;
        const isScrollingUp = currentScrollY < lastScrollY.current;
            const isAtTop = currentScrollY < 10;
        const threshold = isDesktop ? 135 : 66;

        if (isScrollingUp || isAtTop) {
            setShowHeader(true);
        } else if (currentScrollY > threshold) {
            setShowHeader(false);
        }
        lastScrollY.current = currentScrollY;
    };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isDesktop]);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth >= 1200);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const stickyBase = 72;
    const headerHeight = isDesktop ? 135 : 66;
    const stickyOffset = showHeader ? stickyBase + headerHeight : stickyBase;

    const [matches, setMatches] = useState(
        window.matchMedia("(min-width: 768px)").matches
    )

    useEffect(() => {
        window
        .matchMedia("(min-width: 768px)")
        .addEventListener('change', e => setMatches( e.matches ));
    }, []);


        <div >
        {matches && (<h1>Big Screen</h1>)}
        {!matches && (<h3>Small Screen</h3>)}
        </div>

    return (
        <main>

            <WorkHero src={HeroImgDesktop} alt={"Main screens of the Dignifi app"} className={"d-none d-lg-block"}></WorkHero>
            <WorkHero src={HeroImgMobile} alt={"Main screens of the Dignifi app"} className={"d-lg-none"}></WorkHero>
            <div className={"page-container"}>
                <StickyNav headerOffset={stickyOffset} />
                <WorkSection className={"first"} id={"overview"} ref={overviewRef} style={{scrollMarginTop: getScrollMarginTop(overviewRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements overview"}>
                                    <div>
                                        <h1 className={"h2"}>Dignifi app design</h1>
                                        <p><span className={"semibold"}>Timeline / </span>Spring 2024</p>
                                        <p><span  className={"semibold"}>Involvement / </span>Independent UX researcher and designer</p>
                                        <p><span  className={"semibold"}>Deliverables / </span>Interactive app prototype</p>
                                        <p><span  className={"semibold"}>UX activities / </span>User flow, persona, user testing, branding, UI design</p>
                                        <p><span  className={"semibold"}>Tools used / </span>Adobe XD, Miro, pen and paper, Adobe Illustrator</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12} lg={9}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"} style={{scrollMarginTop:72}}>Overview</p>
                                        <h2 className={"h3"}>Background</h2>
                                        <p>In today's digital world, data is constantly being collected about people, often without their knowledge. From social media platforms, to fitness trackers, to smart home devices, companies are quietly building detailed profiles of our lives.</p>
                                        <p style={{margin: 0}}>The goal of this project was to design an app that empowers users to curate, analyze, and manage their digital footprint. My concept lets them customize their dashboard, set goals, and fine-tune privacy settings for a tailored experience that puts the power over their data back in their hands.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container d-none d-md-block"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Design process</h2>
                                        <img src={DesignProcess} alt={"Design process: brainstorm, research, analysis, design, user testing, delivery; contains multiple iterations of analysis, design, and user testing."} style={{maxWidth: 900, borderRadius: 0}}></img>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>

                <WorkSection className={"grey"} id={"general-research"} ref={generalResearchRef} style={{scrollMarginTop: getScrollMarginTop(generalResearchRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>General research</p>
                                        <h2 className={"h3"}>Industry insights</h2>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                <div className={"insights-container"}>
                                                    <Insight
                                                        number={"01"}
                                                        title={"High privacy awareness, low action"}
                                                        description={"79% of adults are concerned about how companies use their data, according to the Pew Research Center."}>
                                                    </Insight>
                                                    <Insight
                                                        number={"02"}
                                                        title={"Curiosity about data patterns"}
                                                        description={"People enjoy data visualizations and reports about their digital lives, like Spotify Wrapped and Screen Time."}>
                                                    </Insight>
                                                    <Insight
                                                        number={"03"}
                                                        title={"Current tools are fragmented"}
                                                        description={"Most data tracking tools are scattered across different platforms or buried deep in individual apps' settings."}>
                                                    </Insight>
                                                </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <h2 className={"h3"}>Competitors</h2>
                                <div className={"work-elements"}>
                                    <Container>
                                        <Row>
                                            <Col xs={12} lg={9}>
                                                <p style={{margin:0}}>There's no major app that shows all types of data being collected and offers insights for users to take proactive action to achieve their goals, but below are a few of the competitors in the privacy and data management field.</p>
                                            </Col>
                                        </Row>
                                    </Container>
                                    <div className={"competitors-container"}>
                                        <Competitor
                                            src={Competitor1}
                                            alt={""}
                                            name={"Google My Activity"}>
                                        </Competitor>
                                        <Competitor
                                            src={Competitor2}
                                            alt={""}
                                            name={"Apple Privacy Settings"}>
                                        </Competitor>
                                        <Competitor
                                            src={Competitor3}
                                            alt={""}
                                            name={"Individual app settings"}>
                                        </Competitor>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>

                <WorkSection id={"user-research"} ref={userResearchRef} style={{scrollMarginTop: getScrollMarginTop(userResearchRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>User research</p>
                                        <h2 className={"h3"}>Pain points</h2>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <div className={"pain-points-container"}>
                                                        <PainPoint
                                                            src={TargetAudiencePink}
                                                            alt={""}
                                                            quote1={"“Every single app I use collects data on me, but I don't know about any of it. "}
                                                            semibold={"I don't know where to start"}
                                                            quote2={".”"}
                                                        ></PainPoint>
                                                        <PainPoint
                                                            src={TargetAudienceOrange}
                                                            alt={""}
                                                            quote1={"“Every app has a different privacy policy, and I just end up accepting without reading it. "}
                                                            semibold={"I need something that I can understand"}
                                                            quote2={" without reading a wall of text.”"}
                                                        ></PainPoint>
                                                        <PainPoint
                                                            src={TargetAudienceBlue}
                                                            alt={""}
                                                            quote1={"“I want to be better about tracking my own data, but "}
                                                            semibold={"the system isn't built for people like me"}
                                                            quote2={" to understand it.”"}
                                                        ></PainPoint>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Persona</h2>
                                        <div className={"personas-container"}>
                                            <Persona src={Persona1} className={"attitudes goals behaviors frustrations"} alt={""} name={"Olivia"} demographics={persona1Demographics} attitudes={persona1Attitudes} behaviors={persona1Behaviors} goals={persona1Goals} frustrations={persona1Frustrations}>
                                            </Persona>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"challenge"} className={"challenge dark-background"} ref={challengeRef} style={{scrollMarginTop: getScrollMarginTop(challengeRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12} lg={9}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Challenge</p>
                                        <h2 className={"h3"}>Problem statement</h2>
                                        <p className={"description no-margin"}>Users don’t know what data is collected about them, they have little awareness of what happens to their data, and they don't have a centralized place to view all of their data at once.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id="analysis" className={"grey"} ref={analysisRef} style={{scrollMarginTop: getScrollMarginTop(analysisRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Analysis</p>
                                        <h2 className={"h3"}>User initiation workflow</h2>
                                        <img src={UserInitiationDesktop} alt={""} style={{borderRadius:0, maxWidth: 800}} className={"d-none d-sm-block"}></img>
                                        <img src={UserInitiationMobile} alt={""} style={{borderRadius:0, maxWidth: 370, marginTop: 12}} className={"d-sm-none"}></img>
                                        <div className={"sr-only"}>
                                            <h3>1. Initial setup and onboarding</h3>
                                            <ul>
                                                <li>Download the app and create an account</li>
                                                <li>Set preferences for data visualizations, privacy settings, and areas of interest</li>
                                                <li>App explains how it will import and analyze personal data, ensuring transparency and consent at every step</li>
                                            </ul>
                                            <h3>2. Data import and aggregation</h3>
                                            <ul>
                                                <li>Connect accounts and devices to the app</li>
                                                <li>App begins importing and aggregating data from these sources, organizing it into different categories based on user preferences</li>
                                            </ul>
                                            <h3>3. Dashboard overview</h3>
                                            <ul>
                                                <li>User is shown a comprehensive dashboard that provides an overview of their personal data</li>
                                                <li>App displays key metrics and insights across different areas</li>
                                                <li>Customize the dashboard layout and prioritize the information that is most relevant</li>
                                            </ul>
                                            <h3>4. Exploring data visualizations</h3>
                                            <ul>
                                                <li>Explore visualizations within the app, including charts, graphs, and interactive maps</li>
                                                <li>Drill down into specific categories or time periods to gain deeper insights</li>
                                                <li>Look at explanations and context for each visualization, helping to interpret the data and identify meaningful patterns or trends</li>
                                            </ul>
                                            <h3>5. Setting goals</h3>
                                            <ul>
                                                <li>Set specific goals and targets for future metrics</li>
                                                <li>App offers personalized recommendations and suggestions to help achieve goals, taking into account preferences and past behavior</li>
                                            </ul>
                                            <h3>6. Actionable insights</h3>
                                            <ul>
                                                <li>App continuously analyzes data in real-time and provides actionable insights and recommendations to support user goals</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"iterations"} className={"design-iterations"} ref={iterationsRef} style={{scrollMarginTop: getScrollMarginTop(iterationsRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Design iterations</p>
                                        <h2 className={"h3"}>Sketches</h2>
                                        <img src={Sketches} alt={""} style={{borderRadius: 0}}></img>
                                        <p className={"img-caption"}>Sketches of the main screens of the app, including sign up/login, home, goals, data import, friends, and settings.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Low-fidelity wireframes</h2>
                                        <img src={LowWireframes} alt={""}></img>
                                        <p className={"img-caption"}>Low-fidelity wireframes produced based on the sketches.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>High-fidelity wireframes</h2>
                                        <img src={HighWireframes} alt={""}></img>
                                        <p className={"img-caption"}>High-fidelity wireframes produced based on the sketches and low-fidelity wireframes.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h3 className={"h4 section-title"}>User testing</h3>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <p>Users were asked to think aloud while completing certain tasks. The research methodology was designed to determine user satisfaction, evaluate usability, and understand feature relevance.</p>
                                                    <p>Specific areas of concern included: login/sign up functionality, goal status symbols and text, visualization comprehension, navigation, goal interactions, connected accounts comprehension and intuitiveness, filtering, nomenclature, understanding of group goals, and accessibility.</p>
                                                    <p style={{marginBottom: 30}}><a href={Transcript} target={"_blank"} rel="noreferrer" style={{textUnderlineOffset: 2, outlineOffset: 4, borderRadius: 2}} aria-label={"Read full user testing transcript - PDF - opens in a new tab"}>Read full user testing transcript<span style={{marginLeft: 4}}><FontAwesomeIcon icon={faExternalLink} style={{fontSize: 12}}/></span></a></p>
                                                    <h4 className={"h5"}>Insights</h4>
                                                    <div className={"insights-container"}>
                                                        <Insight
                                                            number={"01"}
                                                            title={"Not enough information"}
                                                            description={"Users successfully identified their current goal status, but wanted more intuitive and informative data visualizations to better interpret progress."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"02"}
                                                            title={"Limited filtering options"}
                                                            description={"Users expressed a desire for flexible filters to better explore their personal data trends."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"03"}
                                                            title={"Data import confusion"}
                                                            description={'Users found the name "data import" unclear, struggled with the layout, and were unsure about the icon in the navigation.'}>
                                                        </Insight>
                                                        <Insight
                                                            number={"04"}
                                                            title={"Accessibility issues"}
                                                            description={'Some users found issues with color contrast, especially in visualizations and on the "create a goal" screen.'}>
                                                        </Insight>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"final-design"} className={"final-design grey"} ref={finalDesignRef} style={{scrollMarginTop: getScrollMarginTop(finalDesignRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Final design</p>
                                        <h2 className={"h3"}>Final deliverables</h2>
                                        <p><a href={"https://xd.adobe.com/view/545ac97c-6337-4b7a-907c-755a464e05ad-0109/"} target={"_blank"} rel="noreferrer" style={{outlineOffset: 4, borderRadius: 2}}>View interactive prototype<span style={{marginLeft: 4}}><FontAwesomeIcon icon={faExternalLink} style={{fontSize: 12}}/></span></a></p>
                                        <img src={Final} alt={""}></img>
                                        <p className={"img-caption"}>Final design of the Dignifi app.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h3 className={"h4 section-title"}>Changes made from previous iterations</h3>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <div className={"insights-container no-title"}>
                                                        <Insight
                                                            number={"01"}
                                                            className={"no-title"}
                                                            title={null}
                                                            description={'Added "daily," "weekly," and "monthly" filters and calendar views for metrics'}>
                                                        </Insight>
                                                        <Insight
                                                            number={"02"}
                                                            className={"no-title"}
                                                            title={null}
                                                            description={"Adjusted colors across visualizations to fix accessibility issues and help identify noteworthy insights"}>
                                                        </Insight>
                                                        <Insight
                                                            number={"03"}
                                                            className={"no-title"}
                                                            title={null}
                                                            description={'Revamped the "account connection" (previously "data import") page’s organization and filters to improve scanability, reduce scroll depth, and increase understanding.'}>
                                                        </Insight>
                                                        <Insight
                                                            number={"04"}
                                                            className={"no-title"}
                                                            title={null}
                                                            description={"Added information about individual contributions within group goals."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"05"}
                                                            className={"no-title"}
                                                            title={null}
                                                            description={'Added "notifications" and "add friend" screens to meet user needs.'}>
                                                        </Insight>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"reflections"} className={"reflections dark-background"} ref={reflectionsRef} style={{scrollMarginTop: getScrollMarginTop(reflectionsRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Reflections</p>
                                        <h2 className={"h3"}>What I learned</h2>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <p className="summary">Starting with nearly unlimited user data and narrowing it down to a digestible scope was a challenging task, but it sharpened my ability to prioritize what truly matters. Comprehensive user testing proved invaluable throughout the project, revealing insights I couldn’t have uncovered through my own perspective alone.</p>
                                                    <div className={"insights-container"}>
                                                        <Insight
                                                            number={"01"}
                                                            title={"User research skills"}
                                                            description={"I improved my ability to conduct user testing and synthesize results into actionable design decisions."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"02"}
                                                            title={"Importance of empathetic language"}
                                                            description={"Naming and labeling matter—unclear terms and icons eroded usability on multiple pages in early iterations."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"03"}
                                                            title={"Designing for accessibility helps everyone"}
                                                            description={"Though none of the users I conducted testing on had disabilities affecting their use of the app, they still benefited from accessibility changes."}>
                                                        </Insight>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Future considerations</h2>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <div className={"insights-container"}>
                                                        <Insight
                                                            number={"01"}
                                                            title={"Advanced data analysis"}
                                                            description={"Incorporate machine learning and AI capabilities to provide more advanced data analysis and predictive insights, allowing users to anticipate trends and make informed decisions proactively."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"02"}
                                                            title={"Community engagement"}
                                                            description={"Foster a sense of community and collaboration among users by enabling users to connect, share insights, and learn from each other."}>
                                                        </Insight>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection className={"recommendations"} id={"reflections"}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Explore other projects</h2>
                                        <Container>
                                            <Row style={{rowGap: 24, justifyContent: "space-between"}}>
                                                <Col xs={12} sm={6} md={4} lg={3} className={"work-recommendation-container"}>
                                                    <WorkRecommendation
                                                        src={SouthwestThumbnail}
                                                        alt={"Three screens from the redesigned Southwest Airlines app"}
                                                        title={"Southwest Airlines"}
                                                        description={"App redesign (concept)"}
                                                        href={"/southwest-app-redesign"}>
                                                    </WorkRecommendation>
                                                </Col>
                                                <Col xs={12} sm={6} md={4} lg={3} className={"work-recommendation-container"}>
                                                    <WorkRecommendation
                                                        src={InsightThumbnail}
                                                        alt={"Prototype of the InSight AR device and one screen from the InSight app"}
                                                        title={"InSight"}
                                                        description={"AR experience and app design"}
                                                        href={"/insight-ar-app-design"}>
                                                    </WorkRecommendation>
                                                </Col>
                                                <Col xs={12} sm={6} md={4} lg={3} className={"work-recommendation-container"}>
                                                    <WorkRecommendation
                                                        src={SmartHomeThumbnail}
                                                        alt={"Mobile and desktop views of the Renesas Smart Home infographic"}
                                                        title={"Renesas Smart Home"}
                                                        description={"Interactive infographic"}
                                                        href={"/smart-home-infographic"}>
                                                    </WorkRecommendation>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
            </div>
        </main>
    )
}

export default DignifiAppDesign;